import { useState } from 'react';

export enum FILE_LOADING_STATE {
  END = 'END',
  LOADING = 'LOADING',
  FINISHING = 'FINISHING',
}

export const useLoadingFile = () => {
  const [loadingState, setLoadingState] = useState<FILE_LOADING_STATE>(
    FILE_LOADING_STATE.END,
  );

  const startLoading = () => {
    setLoadingState(FILE_LOADING_STATE.LOADING);
  };

  const finishLoading = () => {
    setLoadingState(FILE_LOADING_STATE.FINISHING);
  };

  const endLoading = () => {
    setLoadingState(FILE_LOADING_STATE.END);
  };

  return {
    loadingState,
    startLoading,
    finishLoading,
    endLoading,
  };
};
